import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Table from '@material-ui/core/Table'
import messages from 'components/Apps/SensorsMonitor/translate'
import licenseeDigitFormat from 'helpers/licenseeDigitFormat'

class SummaryTable extends Component {
  tableHeader = () => {
    const {
      intl: { formatMessage },
    } = this.props
    const tableLabels = {
      parameter: formatMessage(messages.parameter),
      min: formatMessage(messages.min),
      mean: formatMessage(messages.mean),
      max: formatMessage(messages.max),
      records: `% ${formatMessage(messages.records)}`,
    }

    return Object.keys(tableLabels).map((key, index) => (
      <TableCell key={index} className="sensors-table-cell-head">
        {tableLabels[key]}
      </TableCell>
    ))
  }

  tableBody = () => {
    const { sensorsData, licensee } = this.props
    const summary = sensorsData.get('summary')

    if (summary) {
      return summary.map((key, index) => {
        let { min, max, mean, records_over_max } = key
        const { parameter, unit } = key
        min =
          typeof min === 'number' && !Number.isInteger(min)
            ? min.toFixed(2)
            : min
        mean =
          typeof mean === 'number' && !Number.isInteger(mean)
            ? mean.toFixed(2)
            : mean
        max =
          typeof max === 'number' && !Number.isInteger(max)
            ? max.toFixed(2)
            : max
        records_over_max =
          typeof records_over_max === 'number' &&
          !Number.isInteger(records_over_max)
            ? records_over_max.toFixed(2)
            : records_over_max

        return (
          <TableRow key={index}>
            <TableCell align="left" className="sensors-table-cell">
              <span className="environment-cell">{`${parameter} (${unit})`}</span>
            </TableCell>
            <TableCell align="center" className="sensors-table-cell">
              <span className="environment-cell">
                {licenseeDigitFormat(min, licensee)}
              </span>
            </TableCell>
            <TableCell align="center" className="sensors-table-cell">
              <span className="environment-cell">
                {licenseeDigitFormat(mean, licensee)}
              </span>
            </TableCell>
            <TableCell align="center" className="sensors-table-cell">
              <span className="environment-cell">
                {licenseeDigitFormat(max, licensee)}
              </span>
            </TableCell>
            <TableCell align="center" className="sensors-table-cell">
              <span className="environment-cell">
                {licenseeDigitFormat(records_over_max, licensee)}
              </span>
            </TableCell>
          </TableRow>
        )
      })
    }
  }

  render() {
    return (
      <Table aria-label="simple table" className="sensors-table">
        <TableHead>
          <TableRow>{this.tableHeader()}</TableRow>
        </TableHead>

        <TableBody>{this.tableBody()}</TableBody>
      </Table>
    )
  }
}

export default connect(state => ({
  sensorsData: state.getIn(['sensor', 'sensorsData']),
  licensee: state.getIn(['profile', 'profile', 'licensee']),
}))(injectIntl(SummaryTable))
